var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.branch.moduleLoading)?_c('div',[_c('BaseComponentLoader')],1):_c('div',[_c('SampleStatsPanel',{attrs:{"statData":_vm.branch.branchStatData}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }